import { RG66 } from "./SalesSummaryPerProductGroup/RG66"

export const RegionPerformanceByProductGroup = {
  "sections": [
    RG66
  ]
}